// SEO landing content — English only for now (FR follows in a later iteration).
// Used by city pages, service-area pages, alternatives pages, and SEO solution pages.

export const CITIES = [
  {
    slug: "zurich",
    name: "Zürich",
    canton: "Zürich",
    lat: 47.3769,
    lon: 8.5417,
    hero: "POS system Zürich — built in Switzerland, on-site within 48 hours.",
    intro:
      "Restaurants, cafés and retail in Zürich, Oerlikon and Altstetten run on O'javana — a cloud POS with native TWINT, Apple Pay, Google Pay and Tap-to-Pay. Local Swiss team. Same-hour replies, on-site service across the canton.",
    bullets: [
      "On-site within 48 h across Zürich canton",
      "TWINT native — no plugin, no waiting",
      "Tap-to-Pay on iPhone & Android",
      "Hosted in Swiss data centres",
    ],
  },
  {
    slug: "geneva",
    name: "Genève",
    canton: "Genève",
    lat: 46.2044,
    lon: 6.1432,
    hero: "POS system Genève — bilingue FR/EN, native TWINT, on-site under 48 hours.",
    intro:
      "From Carouge to Plainpalais, O'javana powers Geneva restaurants and shops with a cloud POS that takes every payment — cards, TWINT, Apple Pay, Tap-to-Pay — settled to one bank account. Talk to a real Swiss team in French.",
    bullets: [
      "Local field engineers based in Vaud + GE",
      "TWINT, Apple Pay, Google Pay, EMV",
      "Online shop + UberEats integrated",
      "FR / EN / IT / DE phone support",
    ],
  },
  {
    slug: "basel",
    name: "Basel",
    canton: "Basel-Stadt",
    lat: 47.5596,
    lon: 7.5886,
    hero: "POS system Basel — TWINT-first, cloud, offline-capable.",
    intro:
      "Restaurants on Spalenberg, retail in Kleinbasel and food trucks at the Rhine harbour rely on O'javana. Cloud POS that never miss a sale — offline-first, syncs the moment you reconnect.",
    bullets: [
      "Offline-first — never miss a sale",
      "TWINT, Apple Pay, EMV, Tap-to-Pay",
      "Kitchen Display routing included",
      "DE phone support",
    ],
  },
  {
    slug: "bern",
    name: "Bern",
    canton: "Bern",
    lat: 46.9481,
    lon: 7.4474,
    hero: "POS system Bern — Swiss-made, on-site within 48 hours.",
    intro:
      "50 minutes from our Boudry HQ. Restaurants in the Marktgasse, multi-brand franchises and cafés in Bümpliz all run on O'javana — multi-location, offline-first, with TWINT and Tap-to-Pay built in.",
    bullets: [
      "50 minutes from our Boudry HQ",
      "Multi-location dashboard included",
      "TWINT + Tap-to-Pay on every terminal",
      "DE / FR phone support",
    ],
  },
  {
    slug: "lausanne",
    name: "Lausanne",
    canton: "Vaud",
    lat: 46.5197,
    lon: 6.6323,
    hero: "POS system Lausanne — local Swiss team, on-site within 48 hours.",
    intro:
      "Bars on the Rue de Bourg, food trucks at Ouchy and franchises across the canton trust O'javana. Cloud POS with native TWINT, Apple Pay, Google Pay and Tap-to-Pay, plus an online shop that takes commission-free orders.",
    bullets: [
      "Field engineers based in Vaud",
      "Native TWINT, Apple Pay, Google Pay",
      "Commission-free online shop",
      "FR / EN phone support",
    ],
  },
  {
    slug: "lucerne",
    name: "Luzern",
    canton: "Luzern",
    lat: 47.0502,
    lon: 8.3093,
    hero: "POS system Luzern — Swiss-hosted, TWINT-ready.",
    intro:
      "From the Old Town to Reussbühl, O'javana keeps Lucerne hospitality businesses running. One ticket from QR menu to kitchen to receipt — including UberEats and online ordering.",
    bullets: [
      "TWINT, Apple Pay, Google Pay, EMV",
      "QR Order & Pay for table service",
      "UberEats + Online Shop in one ticket",
      "DE phone support",
    ],
  },
  {
    slug: "neuchatel",
    name: "Neuchâtel",
    canton: "Neuchâtel",
    lat: 46.9925,
    lon: 6.9311,
    hero: "POS system Neuchâtel — built here. Supported from here.",
    intro:
      "We're based in Boudry, Canton Neuchâtel. Whether you're in the city centre, Hauterive or Colombier, our engineers can be on-site the same day. Drop by for a coffee and we'll show you the product running on the bench.",
    bullets: [
      "HQ in Boudry · same-day on-site",
      "Showroom — book a visit",
      "TWINT + Tap-to-Pay native",
      "FR phone support",
    ],
  },
  {
    slug: "lugano",
    name: "Lugano",
    canton: "Ticino",
    lat: 46.0037,
    lon: 8.9511,
    hero: "Sistema POS Lugano — Swiss-made, multi-language, TWINT-ready.",
    intro:
      "Restaurants in Lugano-Centro, retail in Paradiso, and franchises across Ticino — all running O'javana cloud POS. Native TWINT, full Italian UI, and on-site service when you need it.",
    bullets: [
      "Italian-language UI + receipts",
      "TWINT, Apple Pay, EMV, Tap-to-Pay",
      "Multi-language phone support",
      "Multi-location dashboard",
    ],
  },
];

export const SERVICE_AREAS = [
  {
    slug: "neuchatel",
    name: "Canton de Neuchâtel",
    summary: "Our home canton. Same-day on-site service from Boudry HQ.",
    cities: ["Neuchâtel", "La Chaux-de-Fonds", "Le Locle", "Boudry", "Colombier", "Hauterive"],
  },
  {
    slug: "vaud",
    name: "Canton de Vaud",
    summary: "Field engineers based in Vaud. On-site within 48 hours.",
    cities: ["Lausanne", "Montreux", "Vevey", "Yverdon-les-Bains", "Nyon", "Renens"],
  },
  {
    slug: "geneva",
    name: "Canton de Genève",
    summary: "Bilingual FR/EN local team. On-site within 48 hours.",
    cities: ["Genève", "Carouge", "Vernier", "Lancy", "Meyrin", "Plan-les-Ouates"],
  },
  {
    slug: "bern",
    name: "Canton of Bern",
    summary: "50 minutes from our Boudry HQ. DE/FR support.",
    cities: ["Bern", "Biel/Bienne", "Thun", "Köniz", "Burgdorf", "Spiez"],
  },
  {
    slug: "lucerne",
    name: "Canton of Luzern",
    summary: "Central Switzerland coverage with multi-language support.",
    cities: ["Luzern", "Emmen", "Kriens", "Horw", "Ebikon", "Sursee"],
  },
  {
    slug: "valais",
    name: "Canton du Valais",
    summary: "Alpine resorts to Rhône valley — on-site within 48 hours.",
    cities: ["Sion", "Martigny", "Sierre", "Monthey", "Verbier", "Zermatt"],
  },
  {
    slug: "basel",
    name: "Basel region",
    summary: "Basel-Stadt and Basel-Landschaft. DE phone support.",
    cities: ["Basel", "Allschwil", "Liestal", "Muttenz", "Riehen", "Pratteln"],
  },
  {
    slug: "zurich",
    name: "Canton of Zürich",
    summary: "Greater Zürich area — restaurants, retail and franchises.",
    cities: ["Zürich", "Winterthur", "Uster", "Dübendorf", "Wetzikon", "Kloten"],
  },
  {
    slug: "jura",
    name: "Canton du Jura",
    summary: "Local service from our Boudry HQ, just over the canton border.",
    cities: ["Delémont", "Porrentruy", "Saignelégier", "Courrendlin", "Bassecourt", "Alle"],
  },
];

export const ALTERNATIVES = [
  {
    slug: "lightspeed",
    competitor: "Lightspeed",
    eyebrow: "Lightspeed alternative — Switzerland",
    hero: "The Lightspeed alternative built in Switzerland.",
    intro:
      "More than 80% of small and mid-sized hospitality businesses find Lightspeed too big and too complex for their actual use case. Layered menus, heavy per-station licenses, a hardware bill in the thousands, and a global support queue when things break. O'javana is the focused, Swiss-made alternative — much less expensive, much better suited.",
    competitor_pains: [
      "Too big, too complex — 80%+ of SMB hospitality finds it overwhelming",
      "No local Swiss support — global ticket queue when things break",
      "Costly hardware bundles — often CHF 2,000 – 3,000 up-front",
      "Heavy per-station license fees",
      "Catastrophic support during a breakdown — days of downtime reported",
      "No native Self-Order Kiosk",
      "No e-commerce / online shop module",
      "No customer mobile app",
    ],
    our_wins: [
      "Starter at CHF 39/month with our terminal — full POS, no per-feature unlock",
      "Free POS bundle for eligible merchants (CHF 20K+/mo card sales)",
      "0.90% card processing on every transaction with our terminals",
      "Same-hour replies · on-site within 48 h · phone support in FR/DE/EN/IT",
      "Native Self-Order Kiosk 23.8\" included on Freedom",
      "Online Shop (commission-free) on Complete and Freedom",
      "Customer mobile app + loyalty + physical & e-gift cards",
      "Real product depth — at a fraction of the cost",
    ],
  },
  {
    slug: "sumup",
    competitor: "SumUp",
    eyebrow: "SumUp alternative — Switzerland",
    hero: "The SumUp alternative that's actually a POS.",
    intro:
      "SumUp is great for a market stall or a one-off pop-up. But the hardware is outdated, mostly Bluetooth-tethered, the card rate is 2.5%, there's no SIM connectivity, the POS software is sluggish and very basic, and there's no local Swiss support when your floor needs it. O'javana gives you a real POS — Tap-to-Pay terminals from CHF 150, 0.90% card rate, a Swiss team that picks up the phone.",
    competitor_pains: [
      "Outdated Bluetooth-tethered card readers — old and slow",
      "2.5% credit-card fees — high, and not negotiable",
      "No SIM connectivity — falls over the moment Wi-Fi drops",
      "Sluggish POS software, very basic feature set",
      "No local Swiss support",
      "Cheap hardware build quality",
      "No e-commerce / online shop",
      "No Self-Order Kiosk",
      "No Waiter App",
      "Very limited scope — a card reader pretending to be a POS",
    ],
    our_wins: [
      "Tap-to-Pay payment terminals from CHF 150 (AMS1 with embedded 4G SIM)",
      "0.90% card processing with our terminals — vs SumUp's 2.5%",
      "Real cloud POS — multi-station, offline-first, KDS-ready",
      "Local Swiss team in Neuchâtel · same-hour replies · 48 h on-site",
      "Native Self-Order Kiosk, Waiter App, Online Shop",
      "Loyalty, physical and digital gift cards included",
      "Built for actual restaurants and retail — not occasional sales",
    ],
  },
  {
    slug: "paymash",
    competitor: "Paymash",
    eyebrow: "Paymash alternative — Switzerland",
    hero: "The Paymash alternative — deeper product, real FR support.",
    intro:
      "Paymash is a fine Swiss starting point, but the backend is very basic, the hardware is very expensive, hardware configuration is notoriously difficult, and there is no French phone support. No kiosk, no advanced features. O'javana gives you a deeper product, easier setup, much cheaper hardware, and a real French-speaking Swiss team.",
    competitor_pains: [
      "Very basic backend — limited reporting and configuration depth",
      "Very expensive hardware",
      "No French phone support",
      "Difficult, painful hardware configuration",
      "No Self-Order Kiosk",
      "Basic feature set — no advanced restaurant workflows",
    ],
    our_wins: [
      "Deep backend — multi-location, multi-brand, full inventory & recipe control",
      "Hardware bundle free for eligible merchants — and CHF 1,065 outright otherwise",
      "Phone support in FR · DE · EN · IT — from a real Swiss team",
      "5-minute, plug-and-play hardware setup (we ship pre-configured)",
      "Native Self-Order Kiosk 23.8\" — included on Freedom",
      "Kitchen Display, Customer Display, Waiter App, QR Order & Pay all native",
      "Free migration: menus, products and reports moved at no cost",
    ],
  },
];

export const SEO_SOLUTIONS = [
  {
    slug: "waiter-app-pos",
    eyebrow: "Waiter app POS system",
    hero: "Waiter app POS — table service that just works.",
    intro:
      "iOS and Android handheld POS for table service. Course firing, split/merge checks, tip pool ready. Synced to the kitchen the moment you press send — even if the Wi-Fi flickers.",
    bullets: [
      "iOS + Android — no special hardware",
      "Course firing & split/merge",
      "Tip pool & cash-out support",
      "Offline-capable — never lose an order",
      "Direct-to-kitchen routing (KDS)",
    ],
  },
  {
    slug: "foodtruck-pos",
    eyebrow: "Food truck POS",
    hero: "Food truck POS — offline-first, SIM-ready terminal.",
    intro:
      "A POS designed for life off-grid: O'javana works offline and syncs the second you reconnect. The AMS1 payment terminal ships with an embedded SIM — no Wi-Fi, no problem. TWINT + Tap-to-Pay built in.",
    bullets: [
      "Offline-first — never miss a sale",
      "AMS1 terminal with embedded SIM (4G)",
      "TWINT, Apple Pay, Google Pay, Tap-to-Pay",
      "End-of-service Z-report in one tap",
      "Multi-event reporting from one dashboard",
    ],
  },
  {
    slug: "taptopay-terminals",
    eyebrow: "Tap-to-Pay payment terminals",
    hero: "Tap-to-Pay & EMV terminals — built into the POS.",
    intro:
      "Through our Swisspayout collaboration, every O'javana terminal, kiosk and online checkout accepts contactless, EMV, TWINT, Apple Pay and Google Pay — settled to a single account. Tap-to-Pay on iPhone and Android available as well.",
    bullets: [
      "Tap-to-Pay on iPhone (iOS 16.4+)",
      "Tap-to-Pay on Android (NFC enabled)",
      "S1F2 wired terminal · AMS1 with SIM",
      "0.90% card rate with O'javana terminals",
      "PCI DSS · 3-D Secure 2 · GDPR",
    ],
  },
  {
    slug: "local-support-pos",
    eyebrow: "Local POS support — Switzerland",
    hero: "Local POS support — real people in Neuchâtel.",
    intro:
      "No overseas call-centre, no ticket queue, no week-long waits. When your POS goes down, the same Swiss engineer who installed it picks up the phone. Same-hour replies. On-site within 48 hours. Across Switzerland.",
    bullets: [
      "Operated from Neuchâtel · Switzerland",
      "Same-hour replies, same-day fixes",
      "On-site help within 48 hours",
      "Phone support in FR · DE · EN · IT",
      "Dedicated success manager on Complete & Freedom",
    ],
  },
];


// FR overlays ------------------------------------------------------------------
const CITIES_FR = {
  zurich: {
    hero: "Système de caisse Zürich — fabriqué en Suisse, intervention sur site sous 48 h.",
    intro:
      "Restaurants, cafés et commerces à Zürich, Oerlikon et Altstetten fonctionnent avec O'javana — une caisse cloud avec TWINT natif, Apple Pay, Google Pay et Tap-to-Pay. Équipe suisse locale. Réponse dans l'heure, service sur site dans tout le canton.",
    bullets: [
      "Intervention sous 48 h dans tout le canton de Zürich",
      "TWINT natif — sans plugin ni délai",
      "Tap-to-Pay sur iPhone & Android",
      "Hébergé dans des centres de données suisses",
    ],
  },
  geneva: {
    hero: "Système de caisse Genève — bilingue FR/EN, TWINT natif, sur site sous 48 h.",
    intro:
      "De Carouge à Plainpalais, O'javana équipe les restaurants et boutiques genevoises d'une caisse cloud acceptant tous les paiements — cartes, TWINT, Apple Pay, Tap-to-Pay — réglés sur un seul compte bancaire. Parlez à une vraie équipe suisse en français.",
    bullets: [
      "Techniciens de terrain basés en VD + GE",
      "TWINT, Apple Pay, Google Pay, EMV",
      "Boutique en ligne + UberEats intégrés",
      "Support téléphonique FR / EN / IT / DE",
    ],
  },
  basel: {
    hero: "Système de caisse Bâle — TWINT-first, cloud, capable hors-ligne.",
    intro:
      "Restaurants de la Spalenberg, commerces de Kleinbasel et food trucks au port du Rhin font confiance à O'javana. Une caisse cloud qui ne rate jamais une vente — offline-first, synchronisée dès la reconnexion.",
    bullets: [
      "Offline-first — aucune vente ratée",
      "TWINT, Apple Pay, EMV, Tap-to-Pay",
      "Routage Kitchen Display inclus",
      "Support téléphonique DE",
    ],
  },
  bern: {
    hero: "Système de caisse Berne — Swiss-made, intervention sur site sous 48 h.",
    intro:
      "À 50 minutes de notre siège de Boudry. Restaurants de la Marktgasse, franchises multi-marques et cafés de Bümpliz tournent tous sous O'javana — multi-sites, offline-first, avec TWINT et Tap-to-Pay intégrés.",
    bullets: [
      "À 50 minutes de notre siège de Boudry",
      "Tableau de bord multi-sites inclus",
      "TWINT + Tap-to-Pay sur chaque terminal",
      "Support téléphonique DE / FR",
    ],
  },
  lausanne: {
    hero: "Système de caisse Lausanne — équipe suisse locale, sur site sous 48 h.",
    intro:
      "Bars de la Rue de Bourg, food trucks d'Ouchy et franchises du canton font confiance à O'javana. Caisse cloud avec TWINT, Apple Pay, Google Pay et Tap-to-Pay natifs, plus une boutique en ligne sans commission.",
    bullets: [
      "Techniciens de terrain basés en Vaud",
      "TWINT, Apple Pay, Google Pay natifs",
      "Boutique en ligne sans commission",
      "Support téléphonique FR / EN",
    ],
  },
  lucerne: {
    hero: "Système de caisse Lucerne — hébergé en Suisse, prêt pour TWINT.",
    intro:
      "De la vieille ville à Reussbühl, O'javana fait tourner les commerces lucernois. Un seul ticket du menu QR à la cuisine au reçu — UberEats et commande en ligne inclus.",
    bullets: [
      "TWINT, Apple Pay, Google Pay, EMV",
      "Commande & paiement QR à table",
      "UberEats + Boutique en ligne en un ticket",
      "Support téléphonique DE",
    ],
  },
  neuchatel: {
    hero: "Système de caisse Neuchâtel — conçu ici. Soutenu d'ici.",
    intro:
      "Nous sommes basés à Boudry, canton de Neuchâtel. Au centre-ville, à Hauterive ou à Colombier, nos techniciens interviennent le jour-même. Passez prendre un café au showroom et nous vous montrerons le produit en action.",
    bullets: [
      "Siège à Boudry · intervention jour-même",
      "Showroom — réservez votre visite",
      "TWINT + Tap-to-Pay natifs",
      "Support téléphonique FR",
    ],
  },
  lugano: {
    hero: "Sistema POS Lugano — fabriqué en Suisse, multilingue, prêt pour TWINT.",
    intro:
      "Restaurants à Lugano-Centro, commerces à Paradiso, franchises du Tessin — tous équipés d'O'javana. TWINT natif, interface complète en italien, et intervention sur site à la demande.",
    bullets: [
      "Interface & tickets en italien",
      "TWINT, Apple Pay, EMV, Tap-to-Pay",
      "Support téléphonique multilingue",
      "Tableau de bord multi-sites",
    ],
  },
};

const SERVICE_AREAS_FR = {
  neuchatel: { name: "Canton de Neuchâtel", summary: "Notre canton d'origine. Service sur site le jour-même depuis le siège de Boudry." },
  vaud: { name: "Canton de Vaud", summary: "Techniciens basés en Vaud. Intervention sur site sous 48 h." },
  geneva: { name: "Canton de Genève", summary: "Équipe locale bilingue FR/EN. Intervention sur site sous 48 h." },
  bern: { name: "Canton de Berne", summary: "À 50 minutes de notre siège de Boudry. Support DE/FR." },
  lucerne: { name: "Canton de Lucerne", summary: "Couverture de la Suisse centrale avec support multilingue." },
  valais: { name: "Canton du Valais", summary: "Des stations alpines à la vallée du Rhône — intervention sous 48 h." },
  basel: { name: "Région bâloise", summary: "Bâle-Ville et Bâle-Campagne. Support téléphonique DE." },
  zurich: { name: "Canton de Zürich", summary: "Grand Zürich — restaurants, commerces et franchises." },
  jura: { name: "Canton du Jura", summary: "Service local depuis notre siège de Boudry, juste de l'autre côté de la frontière cantonale." },
};

const ALTERNATIVES_FR = {
  lightspeed: {
    eyebrow: "Alternative à Lightspeed — Suisse",
    hero: "L'alternative à Lightspeed conçue en Suisse.",
    intro:
      "Plus de 80 % des PME de l'hôtellerie-restauration trouvent Lightspeed trop grand et trop complexe pour leur réalité. Menus en cascade, lourdes licences par poste, facture matériel à plusieurs milliers et file d'attente globale quand quelque chose casse. O'javana est l'alternative ciblée, suisse — beaucoup moins chère, beaucoup mieux adaptée.",
    competitor_pains: [
      "Trop grand, trop complexe — 80 %+ des PME hôtelières le trouvent envahissant",
      "Pas de support suisse local — file de tickets globale en cas de panne",
      "Bundles matériel coûteux — souvent CHF 2 000 – 3 000 d'avance",
      "Lourdes licences par poste de caisse",
      "Support catastrophique en cas de panne — jours de coupure rapportés",
      "Pas de borne en libre-service native",
      "Pas de module e-commerce / boutique en ligne",
      "Pas d'app mobile client",
    ],
    our_wins: [
      "Starter à CHF 39/mois avec notre terminal — caisse complète, aucun déblocage",
      "Bundle POS offert pour les commerçants éligibles (CHF 20K+/mois de ventes carte)",
      "0,90 % de commission carte sur chaque transaction avec nos terminaux",
      "Réponse dans l'heure · intervention sous 48 h · support FR/DE/EN/IT",
      "Borne 23,8\" native incluse dans Freedom",
      "Boutique en ligne (sans commission) sur Complete et Freedom",
      "App client mobile + fidélité + cartes cadeaux physiques & numériques",
      "Une vraie profondeur produit — à une fraction du coût",
    ],
  },
  sumup: {
    eyebrow: "Alternative à SumUp — Suisse",
    hero: "L'alternative à SumUp qui est vraiment une caisse.",
    intro:
      "SumUp convient pour un stand de marché ou un pop-up ponctuel. Mais le matériel est dépassé, principalement en Bluetooth, le taux carte est de 2,5 %, sans carte SIM, le logiciel de caisse est lent et très basique, et il n'y a pas de support local suisse quand votre salle en a besoin. O'javana vous offre une vraie caisse — terminaux Tap-to-Pay à partir de CHF 150, taux carte à 0,90 %, une équipe suisse qui décroche le téléphone.",
    competitor_pains: [
      "Lecteurs carte Bluetooth dépassés — vieux et lents",
      "Frais carte 2,5 % — élevés et non négociables",
      "Pas de connectivité SIM — tombe dès que le Wi-Fi flanche",
      "Logiciel de caisse lent, jeu de fonctions très basique",
      "Pas de support suisse local",
      "Qualité de fabrication matériel médiocre",
      "Pas d'e-commerce / boutique en ligne",
      "Pas de borne en libre-service",
      "Pas d'app serveur",
      "Portée très limitée — un lecteur carte qui se fait passer pour une caisse",
    ],
    our_wins: [
      "Terminaux Tap-to-Pay dès CHF 150 (AMS1 avec SIM 4G intégrée)",
      "0,90 % de commission carte avec nos terminaux — contre 2,5 % chez SumUp",
      "Vraie caisse cloud — multi-postes, offline-first, compatible KDS",
      "Équipe suisse locale à Neuchâtel · réponse dans l'heure · 48 h sur site",
      "Borne en libre-service, app serveur et boutique en ligne natives",
      "Fidélité, cartes cadeaux physiques et numériques incluses",
      "Conçu pour de vrais restaurants et commerces — pas des ventes ponctuelles",
    ],
  },
  paymash: {
    eyebrow: "Alternative à Paymash — Suisse",
    hero: "L'alternative à Paymash — produit plus profond, vrai support FR.",
    intro:
      "Paymash est un bon point de départ suisse, mais le backend est très basique, le matériel est très coûteux, la configuration matériel est notoirement difficile, et il n'y a pas de support téléphonique en français. Pas de borne, pas de fonctions avancées. O'javana vous donne un produit plus profond, une mise en place plus simple, du matériel bien moins cher et une vraie équipe suisse francophone.",
    competitor_pains: [
      "Backend très basique — reporting et configuration limités",
      "Matériel très coûteux",
      "Pas de support téléphonique en français",
      "Configuration matériel difficile et pénible",
      "Pas de borne en libre-service",
      "Jeu de fonctions basique — pas de workflows restauration avancés",
    ],
    our_wins: [
      "Backend profond — multi-sites, multi-marques, stocks & recettes complets",
      "Bundle matériel offert pour les éligibles — sinon CHF 1 065 ferme",
      "Support téléphonique en FR · DE · EN · IT — par une vraie équipe suisse",
      "Installation matériel en 5 minutes (livrée pré-configurée)",
      "Borne 23,8\" native — incluse dans Freedom",
      "Kitchen Display, Customer Display, app serveur, QR Order & Pay natifs",
      "Migration gratuite : menus, produits et rapports sans frais",
    ],
  },
};

const SEO_SOLUTIONS_FR = {
  "waiter-app-pos": {
    eyebrow: "Caisse mobile serveur",
    hero: "App serveur — le service à table qui fonctionne vraiment.",
    intro:
      "Caisse mobile iOS et Android pour le service à table. Envoi par plats, division/fusion d'additions, pool de pourboires prêt. Synchronisée avec la cuisine dès que vous appuyez sur envoyer — même si le Wi-Fi vacille.",
    bullets: [
      "iOS + Android — aucun matériel spécial",
      "Envoi par plats & division/fusion",
      "Pool de pourboires & cash-out",
      "Capable hors-ligne — aucune commande perdue",
      "Routage direct vers la cuisine (KDS)",
    ],
  },
  "foodtruck-pos": {
    eyebrow: "Caisse food truck",
    hero: "Caisse food truck — offline-first, terminal avec SIM intégrée.",
    intro:
      "Une caisse pensée pour la vie hors-grille : O'javana fonctionne hors-ligne et se synchronise dès la reconnexion. Le terminal de paiement AMS1 est livré avec une SIM intégrée — pas de Wi-Fi, pas de problème. TWINT + Tap-to-Pay intégrés.",
    bullets: [
      "Offline-first — aucune vente ratée",
      "Terminal AMS1 avec SIM 4G intégrée",
      "TWINT, Apple Pay, Google Pay, Tap-to-Pay",
      "Rapport Z de fin de service en un clic",
      "Reporting multi-événements depuis un seul tableau de bord",
    ],
  },
  "taptopay-terminals": {
    eyebrow: "Terminaux de paiement Tap-to-Pay",
    hero: "Terminaux Tap-to-Pay & EMV — intégrés à la caisse.",
    intro:
      "Grâce à notre collaboration avec Swisspayout, chaque terminal, borne et paiement en ligne O'javana accepte le sans contact, EMV, TWINT, Apple Pay et Google Pay — réglés sur un seul compte. Tap-to-Pay sur iPhone et Android également disponible.",
    bullets: [
      "Tap-to-Pay sur iPhone (iOS 16.4+)",
      "Tap-to-Pay sur Android (NFC activé)",
      "Terminal filaire S1F2 · AMS1 avec SIM",
      "0,90 % de commission carte avec les terminaux O'javana",
      "PCI DSS · 3-D Secure 2 · RGPD",
    ],
  },
  "local-support-pos": {
    eyebrow: "Support de caisse local — Suisse",
    hero: "Support de caisse local — de vraies personnes à Neuchâtel.",
    intro:
      "Pas de centre d'appel à l'étranger, pas de file de tickets, pas de semaines d'attente. Quand votre caisse tombe en panne, c'est le technicien suisse qui l'a installée qui décroche. Réponse dans l'heure. Intervention sous 48 h. Partout en Suisse.",
    bullets: [
      "Exploité depuis Neuchâtel · Suisse",
      "Réponse dans l'heure, correction le jour-même",
      "Intervention sur site sous 48 h",
      "Support téléphonique en FR · DE · EN · IT",
      "Customer Success Manager dédié sur Complete & Freedom",
    ],
  },
};

// Locale-aware getters ---------------------------------------------------------
export function getCity(slug, locale) {
  const base = CITIES.find((c) => c.slug === slug);
  if (!base) return null;
  return locale === "fr" && CITIES_FR[slug] ? { ...base, ...CITIES_FR[slug] } : base;
}
export function getServiceArea(slug, locale) {
  const base = SERVICE_AREAS.find((a) => a.slug === slug);
  if (!base) return null;
  return locale === "fr" && SERVICE_AREAS_FR[slug] ? { ...base, ...SERVICE_AREAS_FR[slug] } : base;
}
export function getAlternative(slug, locale) {
  const base = ALTERNATIVES.find((a) => a.slug === slug);
  if (!base) return null;
  return locale === "fr" && ALTERNATIVES_FR[slug] ? { ...base, ...ALTERNATIVES_FR[slug] } : base;
}
export function getSeoSolution(slug, locale) {
  const base = SEO_SOLUTIONS.find((s) => s.slug === slug);
  if (!base) return null;
  return locale === "fr" && SEO_SOLUTIONS_FR[slug] ? { ...base, ...SEO_SOLUTIONS_FR[slug] } : base;
}
